import React, { Component, useRef, useState, useEffect } from 'react';
import LineworxClient from '../lineworxClient';
import Dropdown from 'react-dropdown'
import 'react-dropdown/style.css'
import { CSSTransition } from 'react-transition-group';
import { throttle, debounce } from "throttle-debounce";
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import DragAndDrop from '../DragNDrop'
// import Modal from './components/Modal/Modal';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import Section from '../components/Section/Section';
import moment from 'moment';
import { handleSorting, sortBy } from '../handleSorting';
//import { getClosestMatch } from '../components/StringUtils/StringUtils';
//import { hasConsecutiveChars } from '../components/StringUtils/ConsecChars';
//import { getLevenshteinDistance } from '../components/StringUtils/DistanceMatch';

import { getDropdownValue, findColumnName } from '../components/StringUtils/GetDropDownValue';

// Import module css
import styles from './Jobs.module.css';
import { get } from 'jquery';

let DEFAULT_DROPDOWN_VALUE = "*** SELECT... ***";


class Jobs extends React.Component {
  
  constructor(props) {
    super(props);
    
    //let dueDateDefault = moment().clone().add(1,'months').format('MM/DD/YYYY');

    this.state={
      //dueDateDefault: dueDateDefault,
      //dueDateDefaultRaw: new Date(dueDateDefault),
      utilities: [],
      utilsForDropdown:[],
      utilsForDropdownCreate:[],
      selectedUtility: "",
      updating:0,
      jobs:[],
      filteredJobs:[],
      searchString:'',
      selectedStatus:'All',
      newJob:null,
      //showCreateJob:false,
      //selectedFilterBy:'Job Number',
      jobNumber:'',
      //sort_dir:"asc",
      // sort_col: "job_number",
      //dueDate:new Date(),
      //packetFile: {name: '', type: '', size: ''},
      //foremenForDropdown:[],
      //selectedForeman:{},
      //jobType: 'normal',
      //hospName: '',
      //hospAddress: '',
      //ambMeetup: '',
      canSaveJob:false,
      loadingNewPacket: false,
      showNetworkError: false,
      showSpinner: false,
      loadingNewTickets: false,
      //startDate:new Date(),
      //endDate:new Date(),
      newExcel: false,
      excelActiveTab: 'tracking',
      newTickets:null,
      canSaveExcel:false,
      loadingNewExcel: true,
      showExcelNetworkError: false, 
    }

    this.updateSearchString = this.updateSearchString.bind(this);
    this.updateSelectedStatus = this.updateSelectedStatus.bind(this);
    this.updateSelectedFilterBy = this.updateSelectedFilterBy.bind(this);
    this.toggleCreateJob = this.toggleCreateJob.bind(this);
    this.onDueDateChange = this.onDueDateChange.bind(this);
    this.saveJob = this.saveJob.bind(this);
    this.canSave = this.canSave.bind(this);
    this.handleJobNumber = this.handleJobNumber.bind(this);
    this.handleHospName = this.handleHospName.bind(this);
    this.handleWorkContactPhone = this.handleWorkContactPhone.bind(this)
    this.checkExistingJobNumber = this.checkExistingJobNumber.bind(this);
    this.handleHospAddress = this.handleHospAddress.bind(this);
    this.handleJobEhasp = this.handleJobEhasp.bind(this);
    this.handleJobArcRating = this.handleJobArcRating.bind(this);
    this.handleJobPrimaryVoltage = this.handleJobPrimaryVoltage.bind(this)
    this.handleJobSecondaryVoltage = this.handleJobSecondaryVoltage.bind(this)
    this.toggleShowDueDateCalendar = this.toggleShowDueDateCalendar.bind(this);
    this.autocompleteSearchDebounced = debounce(1000, this.autocompleteSearch);
    this.autocompleteSearchThrottled = throttle(1000, this.autocompleteSearch);
    this.toggleShowStartDateCalendar = this.toggleShowStartDateCalendar.bind(this);
    this.hideStartDateCalendar = this.hideStartDateCalendar.bind(this);
    this.hideEndDateCalendar = this.hideEndDateCalendar.bind(this);
    this.onStartDateChange = this.onStartDateChange.bind(this);
    this.handleNewSelectUtility=this.handleNewSelectUtility.bind(this);
    this.toggleShowEndDateCalendar = this.toggleShowEndDateCalendar.bind(this);
    this.onEndDateChange = this.onEndDateChange.bind(this);
    this.checkToggleCreateJob=this.checkToggleCreateJob.bind(this);
    this.newJobPacket = React.createRef();
    this.newExcelFileRef = React.createRef();
    this.handleFileSelectClick = this.handleFileSelectClick.bind(this);
    this.handleExcelFileSelectClick = this.handleExcelFileSelectClick.bind(this);
    this.toggleExcelMapping = this.toggleExcelMapping.bind(this);
    this.setNewTickets = this.setNewTickets.bind(this);
    this.updateTickets = this.calcTicketExcelColumn =  this.calcTicketExcelColumn.bind(this);
    this.canSaveExcel = this.canSaveExcel.bind(this);
    this.saveExcelMappings = this.saveExcelMappings.bind(this);
    this.resetExcel = this.resetExcel.bind(this)
    this.editExcel = this.editExcel.bind(this)
    this.resetPacketOfWorkFile = this.resetPacketOfWorkFile.bind(this)
    this.handleSorting = handleSorting.bind(this);
    this.sortBy = sortBy.bind(this);
    this.handleRetry = this.handleRetry.bind(this);
    this.handlePDFRetry = this.handlePDFRetry.bind(this);
    this.handleExcelRetry = this.handleExcelRetry.bind(this);
    this.prefillMappings = this.prefillMappings.bind(this);
    //this.getClosestMatch = getClosestMatch.bind(this);
    //this.getLevenshteinDistance = getLevenshteinDistance.bind(this);
    //this.hasConsecutiveChars = hasConsecutiveChars.bind(this);
    
  }

  prefillMappings(newTickets) {
    if (newTickets.allJobColumns) {
        newTickets = this.calcTicketExcelColumn('ticket', 'work_order', 'work order', newTickets);
        newTickets = this.calcTicketExcelColumn('ticket', 'pole', 'pole', newTickets);
        newTickets = this.calcTicketExcelColumn('ticket', 'line', 'line', newTickets);
        newTickets = this.calcTicketExcelColumn('ticket', 'pole_id', 'pole id', newTickets);
        newTickets = this.calcTicketExcelColumn('ticket', 'line_id', 'line id', newTickets);
        newTickets = this.calcTicketExcelColumn('ticket', 'due_date', 'due date', newTickets);
        newTickets = this.calcTicketExcelColumn('ticket', 'geo_lat', 'lat', newTickets);
        newTickets = this.calcTicketExcelColumn('ticket', 'geo_lon', 'long', newTickets);
        newTickets = this.calcTicketExcelColumn('ticket', 'primary_voltage', 'primary voltage', newTickets);
        newTickets = this.calcTicketExcelColumn('ticket', 'secondary_voltage', 'secondary voltage', newTickets);
        newTickets = this.calcTicketExcelColumn('ticket', 'arc_rating', 'arc rating', newTickets);
        newTickets = this.calcTicketExcelColumn('ticket', 'street', 'street', newTickets);
        newTickets = this.calcTicketExcelColumn('ticket', 'unit_task', 'unit', newTickets);
        newTickets = this.calcTicketExcelColumn('ticket', 'desc', 'description', newTickets);
        newTickets = this.calcTicketExcelColumn('ticket', 'qty', 'quantity', newTickets);
    }

    if (newTickets.allLibraryColumns) {
        newTickets = this.calcTicketExcelColumn('library', 'family', 'family', newTickets);
        newTickets = this.calcTicketExcelColumn('library', 'code', 'unit code', newTickets);
        newTickets = this.calcTicketExcelColumn('library', 'type', 'type', newTickets);
        newTickets = this.calcTicketExcelColumn('library', 'action', 'action', newTickets);
        newTickets = this.calcTicketExcelColumn('library', 'uom', 'uom', newTickets);
        newTickets = this.calcTicketExcelColumn('library', 'desc', 'description', newTickets);
        newTickets = this.calcTicketExcelColumn('library', 'notes', 'notes', newTickets);
    }

    return newTickets;
  }

  saveExcelMappings() {
    let newJob = JSON.parse(JSON.stringify(this.state.newJob));
    newJob.ticketsFile = JSON.parse(JSON.stringify(this.state.newTickets));

    this.setState({
        newJob
    });
  }

  calcTicketExcelColumn(type, field, value, tickets) {
    console.log(tickets)
    let newTickets = JSON.parse(JSON.stringify(tickets || this.state.newTickets));

    if(type === 'ticket') {
      if (!newTickets.ticketsMappings) {
          newTickets.ticketsMappings = {}
      } 
      
      newTickets.ticketsMappings[field] = findColumnName(newTickets?.allJobColumns, value);
      let used = Object.keys(newTickets?.ticketsMappings).map(key => newTickets?.ticketsMappings[key]);

      newTickets.availableJobColumns = newTickets?.allJobColumns?.filter((col) => {
          return used?.indexOf(col)< 0
      });
      
  } else {

      if (!newTickets.libraryMappings) {
          newTickets.libraryMappings = {}
      } 
      newTickets.libraryMappings[field] = findColumnName(newTickets?.allLibraryColumns, value);
      let used = Object.keys(newTickets.libraryMappings).map(key => newTickets.libraryMappings[key]);

      newTickets.availableLibraryColumns = newTickets.allLibraryColumns.filter((col) => {
          return used.indexOf(col)< 0
      });
  }

  return newTickets
}

  setNewTickets(newTickets) {
// console.log(newTickets)
      this.setState({
        newTickets
    }, () => {
        this.canSaveExcel()
    });
  }

  /** Create job functions */

  handleJobNumber(e) {
    //console.warn(this.state.newJob)
    let newJob = this.state.newJob;
    
    newJob.job_number = e.target.value;
    this.setState({
      newJob,
      job_number_exists:null
    }, () => {
        this.canSave()
    });
  }


  async checkExistingJobNumber(e) {

    // console.log(e.target.value);
    if(e.target.value !== '') {
      let result = await LineworxClient.checkExistingJobNumber(e.target.value);
      console.log(result.body)
      if(result.body.length > 0) {
          this.setState({
              job_number_exists : 1
          }, () => {
              this.canSave()
          })
      } else {
          this.setState({
              job_number_exists : 0
          }, () => {
              this.canSave()
          })
      }
    }
    
  }


  handleSelectJobType(option) { 
    // console.log(option);
    let newJob = this.state.newJob;
    newJob.job_type = option === "estimation"? 1 : 0;
    this.setState({
      newJob
    }, () => {
        this.canSave();
    });    
  }

  handleSelectExcelMappingTab(option) {
    // console.log(option)

    this.setState({
      excelActiveTab: option,
    })
  }

  handleNewSelectUtility(e) {
      let newJob = this.state.newJob;
      // console.log(newJob);
      newJob.selected_utility_id = e.value;
      newJob.selected_utility_name = e.label;
      this.setState({
        newJob
      }, () => {
        this.canSave();
      })
  }
  
  onDueDateChange(e) {
    let newJob = this.state.newJob;
    newJob.due_date_default = moment(e).format('MM/DD/YYYY');
    newJob.due_date = e;
    this.setState({
      newJob
    }, () => {
        this.canSave()
    });
    this.hideEndDateCalendar();    
  }

  onStartDateChange(e) {
    let newJob = this.state.newJob;
    newJob.start_date = e;
    this.setState({
      newJob
    });
    this.toggleShowStartDateCalendar();    
  }

  onEndDateChange(e) {
    let newJob = this.state.newJob;
    newJob.end_date = moment.utc(e);
    this.setState({
      newJob
    });
    this.toggleShowEndDateCalendar();    
  }

  resetPacketOfWorkFile() {
    let newJob = this.state.newJob;
    newJob.packet = {};
    newJob.work_packet_url = null;
    newJob.work_packet_name = null;
    newJob.work_packet_size = null;
    newJob.work_packet_type = null;

    this.setState({
      newJob
    }, () => {
      this.canSave()
      // console.log(JSON.stringify(this.state.newJob));
    });

    this.setState({
      loadingNewPacket: false
    });
  }

  resetExcel() {
   
    let newTickets = this.state.newTickets;
    if(newTickets){
      newTickets.packet = null;
      newTickets.ticketsFile = null;
      newTickets.ticket_file_size = null;
      newTickets.ticket_file_type = null;
      newTickets.ticket_file_name = null;
      newTickets.ticket_file_url = null;
      newTickets.libraryColumns = null;
      newTickets.allJobColumns = null;
      newTickets.allLibraryColumns = null;
      newTickets.availableJobColumns = null;
      newTickets.availableLibraryColumns = null;
      newTickets.libraryMappings = {};
      newTickets.ticketsMappings = {};
    }
    console.log(newTickets)

    this.setState({
      newTickets
    })

    let newJob = JSON.parse(JSON.stringify(this.state.newJob));
    newJob.ticketsFile = null

    this.setState({
        newJob
    });

  
  }
  
  handleExcelDrop = async (files) => {
    this.setState({ loadingNewTickets: true, showExcelNetworkError: false });

    try {
        if (files && files.length > 0) {
            let response = await LineworxClient.getUploadUrl("excel");
            let body = response.body;
            let resp = await LineworxClient.uploadFileToS3(body.signedRequest, files[0]);

            if (resp.ok) {
                let colResp = await LineworxClient.getExcelColumns(body.url.replace('https://', 'http://'));
                if (colResp.response.ok !== true) {
                    throw new Error("This Excel file couldn't be parsed.");
                }

                let excelColumnBody = colResp.body;
                if (!excelColumnBody || !excelColumnBody.jobColumns || excelColumnBody.jobColumns.length < 9) {
                    throw new Error("Couldn't find enough Ticket columns in this Excel file.");
                }
                if (!excelColumnBody || !excelColumnBody.libraryColumns || excelColumnBody.libraryColumns.length < 7) {
                    throw new Error("Couldn't find enough Unit Library columns in this Excel file.");
                }

                files[0].uploadUrl = body.signedRequest;
                files[0].url = body.url;

                let newTickets = this.state.newTickets || {};
                newTickets.packet = files[0];
                newTickets.ticket_file_url = body.url.replace('https://', 'http://');
                newTickets.ticket_file_name = files[0].name;
                newTickets.ticket_file_size = files[0].size;
                newTickets.ticket_file_type = files[0].type;
                newTickets.availableLibraryColumns = excelColumnBody.libraryColumns;
                newTickets.allLibraryColumns = excelColumnBody.libraryColumns;
                newTickets.allJobColumns = excelColumnBody.jobColumns;
                newTickets.availableJobColumns = excelColumnBody.jobColumns;
                newTickets.ticketsMappings = {}; 
                newTickets.libraryMappings = {}; 

                newTickets = this.prefillMappings(newTickets);

                this.setState({ newTickets, newExcel: true }, () => {
                    this.canSaveExcel();
                });
            } else {
                throw new Error("File upload failed.");
            }
        }
    } catch (error) {
        console.error("Error during Excel upload:", error.message);
        setTimeout(() => {
          this.setState({ showExcelNetworkError: true, showSpinner: false });
      }, 10000); 
    } finally {
        this.setState({ loadingNewTickets: false });
    }
};

  setDefault = function (type, field, value) {
    const columns = type === 'ticket' ? this.state.newTickets.allJobColumns : this.state.newTickets.allLibraryColumns

    const found = columns.find(c=>c.toLowerCase() === value)
    
    if(found){
      const updateTickets = this.calcTicketExcelColumn(type, field, value)
    }
  }


  handlePacketDrop = async (files) => {
    this.setState({ loadingNewPacket: true, showNetworkError: false, showSpinner: true });

    try {
        if (files && files.length > 0) {
            let response = await LineworxClient.getUploadUrl("work_packet");
            let body = response.body;
            await LineworxClient.uploadFileToS3(body.signedRequest, files[0]);

            files[0].uploadUrl = body.signedRequest;
            files[0].url = body.url;

            // Serialize and deserialize - deep copy intentional here
            let strPacket = JSON.stringify(files[0]);
            let packetObj = JSON.parse(strPacket);
            packetObj.name = files[0].name;
            packetObj.size = files[0].size;
            packetObj.type = files[0].type;

            let newJob = this.state.newJob;
            newJob.packet = packetObj;
            newJob.work_packet_url = body.url;
            newJob.work_packet_name = files[0].name;
            newJob.work_packet_size = files[0].size;
            newJob.work_packet_type = files[0].type;

            this.setState({ newJob, loadingNewPacket: false, showSpinner: false });
        }
    } catch (error) {
        console.error('Error handling packet drop:', error);
        setTimeout(() => {
            this.setState({ showNetworkError: true, showSpinner: false });
        }, 10000); 
    }
};

handleRetry = () => {
    this.setState({
        loadingNewPacket: false,
        showNetworkError: false,
        showSpinner: false,
    });
};

handleRetry = () => {
    this.setState({
        loadingNewTickets: false,
        showExcelNetworkError: false,
    });
};

handlePDFRetry = () => {
    let newJob = this.state.newJob || {};
    newJob.packet = null;
    newJob.work_packet_url = null;
    newJob.work_packet_name = null;
    newJob.work_packet_size = null;
    newJob.work_packet_type = null;

    this.setState({
        newJob,
        loadingNewPacket: false,
        showNetworkError: false,
        showSpinner: false,
    });
};

handleExcelRetry = () => {
    let newTickets = this.state.newTickets || {};
    newTickets.packet = null;
    newTickets.ticketsFile = null;
    newTickets.ticket_file_size = null;
    newTickets.ticket_file_type = null;
    newTickets.ticket_file_name = null;
    newTickets.ticket_file_url = null;
    newTickets.libraryColumns = null;
    newTickets.allJobColumns = null;
    newTickets.allLibraryColumns = null;
    newTickets.availableJobColumns = null;
    newTickets.availableLibraryColumns = null;
    newTickets.libraryMappings = {};
    newTickets.ticketsMappings = {};

    this.setState({
        newTickets,
        loadingNewTickets: false,
        showExcelNetworkError: false,
    });
};

  handleSelectForeman = (option) => {
      let newJob = this.state.newJob;
      newJob.foreman_id = option.value;
      newJob.foreman_name = option.label;
    this.setState({newJob}, () => {this.canSave()});
  }
  
  handleHospName(e) {
    let newJob = this.state.newJob;
    newJob.hospital_name = e.target.value;
    this.setState({
      newJob
    }, () => {
        this.canSave()
    });
  }

  handleWorkContactPhone(e) {
    let newJob = this.state.newJob;
    newJob.work_contact_phone = e.target.value;
    this.setState({
      newJob
    }, () => {
        this.canSave()
    });
  }

  handleHospAddress(e) {
    let newJob = this.state.newJob;
    newJob.hospital_address = e.target.value;
    this.setState({
      newJob
    }, () => {this.canSave()});
  }

  handleJobEhasp(e) {
    let newJob = this.state.newJob;
    newJob.ehasp_override = e.target.value;
    this.setState({
      newJob
    }, () => {this.canSave()});
  }

  handleJobArcRating(e) {
    let newJob = this.state.newJob;
    newJob.arc_rating_override = e.target.value;
    this.setState({
      newJob
    }, () => {this.canSave()});
  }

  handleJobPrimaryVoltage(e) {
    let newJob = this.state.newJob;
    newJob.primary_voltage_override = e.target.value;
    this.setState({
      newJob
    }, () => {this.canSave()});
  }
  handleJobSecondaryVoltage(e) {
    let newJob = this.state.newJob;
    newJob.secondary_voltage_override = e.target.value;
    this.setState({
      newJob
    }, () => {this.canSave()});
  }

  hideStartDateCalendar() {  
    this.setState({
        showStartDateCalendar: false
      })  
  }

  toggleShowDueDateCalendar() {
    this.setState({
      showDueDateCalendar: !this.state.showDueDateCalendar
    }, () => {this.canSave()});    
  }

  toggleShowStartDateCalendar() {
    this.setState({
      showStartDateCalendar: !this.state.showStartDateCalendar
    })
  }

  toggleShowEndDateCalendar() {
    this.setState({
      showEndDateCalendar: !this.state.showEndDateCalendar
    })
  }
  hideEndDateCalendar() { 
      console.log("Hiding end date calendar");
    this.setState({
        showDueDateCalendar: false
      })  
  }

  canSave() {
    let job = this.state.newJob; //createJobObject();

    console.log("canSave")
    console.log(JSON.stringify(job))
    let canSaveJob =  (this.isNotEmpty(job.job_number) 
        && (job.selected_utility_id) 
        && (job.work_packet_name != null)
        && this.state.job_number_exists === 0);

    this.setState({
        canSaveJob
    });
  }

  canSaveExcel() {
    let newTickets = this.state.newTickets;

    let canSaveExcel =  
        newTickets.ticketsMappings['work_order'] &&
        newTickets.ticketsMappings['pole'] &&
        newTickets.ticketsMappings['unit_task'] &&
        newTickets.ticketsMappings['qty'] &&
        newTickets.libraryMappings['family'] &&
        newTickets.libraryMappings['code'] &&
        newTickets.libraryMappings['type'] &&
        newTickets.libraryMappings['action'] &&
        newTickets.libraryMappings['uom'] &&
        newTickets.libraryMappings['desc'] &&
        newTickets.libraryMappings['notes']

    this.setState({
        canSaveExcel
    });
  }

  createJobObject() {
    let job = {};

    job.selected_utility_id = null; //this.state.selectedUtility;
    job.selected_utility_name = null;
    job.foreman_id = null; //this.state.selectedForeman;
    job.foreman_name = null;
    job.due_date = moment().clone().add(1,'months').format('MM/DD/YYYY');//this.state.dueDateDefault;        
    job.job_number = null;//this.state.jobNumber;
    job.job_type = 0; //this.state.jobType === "estimation" ? 1 : 0;

    //The packetFile is a File object which defines it's own toJSON method and hides some of the properties we want
  //   let strPacket = JSON.stringify(this.state.packetFile);
  //   let packetObj = JSON.parse(strPacket);

  //   packetObj.name = this.state.packetFile.name;
  //   packetObj.size = this.state.packetFile.size;
  //   packetObj.type = this.state.packetFile.type;
    
    job.work_packet_name = null;//packetObj;
    job.packet = null;
    job.work_packet_url = null;
    job.work_packet_size = null;
    job.work_packet_type = null;

    job.hospital_name = null;//this.state.hospName;
    job.hospital_address = null;//this.state.hospAddress;
    job.ehasp_override = null;
    job.arc_rating_override = null;
    job.secondary_voltage_override = null;
    job.primary_voltage_override = null;
    return job;
  
}

async saveJob() {
    
    console.log("saving job")
    let job = this.state.newJob; //createJobObject();
    
    job.newTickets = this.state.newTickets


    let response = await LineworxClient.saveJob(job);
    if(response.response.ok) {
        this.toggleCreateJob()
        this.getJobs();
    }
    else {
      if(response.body.error) {
        alert(response.body.error)
      }
      else {
        alert("Error saving job")
      }
    }
  }

  /** End Create Job functions */

  
  isNotEmpty(inVar) {
      
        let ret = false;
        if(inVar) {
            ret = true;
        }
        return ret;
      
  }

  async getForemen() {
    this.setState(prevState => ({
        updating: ++prevState.updating
      }))
  
    
    const fores = await LineworxClient.getForemen();
    
    if(fores.body) {
      let foremenForDropdown = fores.body.map((foreman) => {
        return {
          label:foreman.first_name + ' ' + foreman.last_name,
          value:foreman.id
        }
      });
      this.setState( prevState => ({
        foremen: fores.body,
        foremenForDropdown,
        updating: --prevState.updating
      }));
      
    } else {
        this.setState( prevState => ({
            updating: --prevState.updating
        }));
    }
  }


  async getUtilities() {
    
    this.setState(prevState => ({
      updating: ++prevState.updating
    }))

    const utils = await LineworxClient.getUtilities();
    if(utils.body) {
        
      let utilsForDropdown = utils.body.map((utility) => {
        return {
          label:utility.code,
          value:utility.id
        }
      });

      this.setState( prevState => ({
        utilities: utils.body,
        utilsForDropdown,
        selectedUtility: utilsForDropdown[0],
        updating: --prevState.updating
      }));
    } else {
      this.setState(prevState => ({
        updating: --prevState.updating
      }));
    }
  }

  async getUtilitiesCreate() {
    
    this.setState(prevState => ({
      updating: ++prevState.updating
    }))

    const utils = await LineworxClient.getUtilities();
    if(utils.body) {
        
      let utilsForDropdownCreate = utils.body.map((utility) => {
        return {
          label:utility.code,
          value:utility.id
        }
      });
      this.setState( prevState => ({
        utilities: utils.body,
        utilsForDropdownCreate,
        updating: --prevState.updating
      }));
    } else {
      this.setState(prevState => ({
        updating: --prevState.updating
      }));
    }
  }

  updateSearchString(event) {
    this.setState({ searchString: event.target.value }, () => {
      const val = this.state.searchString;
      
      if (val.length < 5) {
        this.autocompleteSearchThrottled(val);
      } else {
        this.autocompleteSearchDebounced(val);
      }
    });
  }
  
  autocompleteSearch = val => {
    
    
    let filteredJobs = this.filterTheseJobs(this.state.jobs);
    this.setState({
      filteredJobs,
    });
  }

  // updateSearchString(e) {
  //     let val = e.target.value;
  //     this.setState({
  //         searchString: val
  //     }, () => {
          
  //     });
  //     debounce(
  //         (val) => {
              
  //         },
  //         1000);
  // }

  updateSelectedStatus(e) {    
    this.setState({
      selectedStatus:e.target.textContent
    }, () => {

      let filteredJobs = this.filterTheseJobs(this.state.jobs);
      console.log(filteredJobs)
      this.setState({
        filteredJobs,
      });
    });
  }

  updateSelectedFilterBy(e) {
    this.setState({
      selectedFilterBy: e.target.textContent
    }, () => {
      let filteredJobs = this.filterTheseJobs(this.state.jobs);
      this.setState({
        filteredJobs,
      });
    });
  }
/**
 * Filters and sorts the given jobs array based on the selected status and utility.
 * @param {Array} jobs - The jobs array to filter and sort.
 * @returns {Array} The filtered and sorted jobs array.
 */
  filterTheseJobs(jobs) {
    const { selectedStatus, selectedUtility } = this.state;
    const sortByValue = localStorage.getItem('sortBy') || 'job_number';
    const sortDirValue = localStorage.getItem('sortDir') || 'desc';
  
    const filteredJobs = jobs.filter(job => {
      let job_type = job.job_type === 0 ? 'Normal' : 'In Estimation';
      if (selectedStatus !== "All" && job.status !== selectedStatus && job_type !== selectedStatus) {
        return false;
      }
      return true;
    }).sort((a, b) => {
      if (a[sortByValue] < b[sortByValue]) {
        return sortDirValue === 'asc' ? -1 : 1;
      }
      if (a[sortByValue] > b[sortByValue]) {
        return sortDirValue === 'asc' ? 1 : -1;
      }
      return 0;
    });
  
    return filteredJobs;
  }

  hideCalendarFromDocClickIfNeeded(e) {
      console.log(e.target.className);
      if(!e.target.className)return;
      if ((typeof e.target.className) !=="string") {
        // console.log("Saved it ");  
        return
      }
      if(e.target.className.indexOf("calendar") > -1)return;
      if(e.target.id !== "calendar") {
          this.hideEndDateCalendar();
      }
  }

  async getJobs() {
    this.setState(prevState => ({
      updating: ++prevState.updating
    }));
    const jobs = await LineworxClient.getJobs();
    let updating = this.state.updating;
    updating--;
    if(jobs.body) {
      let filteredJobs = this.filterTheseJobs(jobs.body);
        
      this.setState({
        jobs: jobs.body,
        filteredJobs,
        updating
      }, () => { 
        // Get the sort by value from local storage and sort the jobs array based on it
        const sortByValue = localStorage.getItem('sortBy');
        this.sortBy(sortByValue);
        //this.sortBy('job_number');
      });
    } else {
      this.setState({
          updating
      });
    }
  }

  checkToggleCreateJob() {
    let newJob = JSON.stringify(this.state.newJob);
    let emptyJob = JSON.stringify(this.createJobObject());
    if(newJob === emptyJob) {
        this.toggleCreateJob();
        return;
    }
    if(window.confirm("You have unsaved changes. If you close you will lose these changes. Close anyway?")) {
        this.toggleCreateJob();
    } 
  }

  async toggleCreateJob(event) {
      let newJob = this.state.newJob;
      if(!newJob) {
        console.log(`stay`)
          newJob = this.createJobObject();
      } else {
        console.log(`go`)
        this.resetExcel()
          newJob = null;
      }
      this.setState({
        newJob
      })
  }

  toggleExcelMapping() {
    this.setState({
      newExcel: !this.state.newExcel,
    })
  }
  loadSortingDefaults() {
     /**
   * Retrieves the selected sort by and sort direction values from local storage.
   * If the values are not set in local storage, sets the default values.
   */
     const sortByValue = localStorage.getItem('sortBy');
     if (!sortByValue) {
       localStorage.setItem('sortBy', 'job_number');
     }
     const sortDirValue = localStorage.getItem('sortDir');
     if (!sortDirValue) {
       localStorage.setItem('sortDir', 'desc');
     }

  }

  componentDidMount() {
    this.getUtilities();
    this.getUtilitiesCreate();
    this.getJobs();
    this.getForemen();
    this.loadSortingDefaults();
  }

  handleSelectUtility = (option)=> {
    const selectedUtility = option;
    this.setState({
        selectedUtility
    }, () => {
        let filteredJobs = this.filterTheseJobs(this.state.jobs);
        this.setState({
            filteredJobs,
        });
    });
    //
  }

  handlePDFJobPacketUpload(e) {
      this.handlePacketDrop(e.target.files)
  }

  handleExcelJobPacketUpload(e) {
    console.log(`handle excel upload`)
    console.log(e)
    this.handleExcelDrop(e.target.files)
}

  handleFileSelectClick() {
    console.log(`pdf work packet click`)
      this.newJobPacket.current.click();
  }

  handleExcelFileSelectClick() {
    console.log(`excel click`)
    this.newExcelFileRef.current.click();
  }

  editExcel() {
    this.setState({newExcel: true})
  }

  scrollIntoView(idToScrollTo) {
    let element = document.getElementById(idToScrollTo);    
    element.scrollIntoView(true);
  }

  
  render() {
    const {
      selectedUtility,
      utilsForDropdown,
      utilsForDropdownCreate,
      foremenForDropdown,
      foreman_id,
      foreman_name,
      job_number_exists,
      newJob,
      newTickets,
      loadingNewPacket,
      showNetworkError,
      showSpinner
    } = this.state;
    
    return (
      <div className="container-fluid px-0"
        onClick={(e) => this.hideCalendarFromDocClickIfNeeded(e)}
      >
        
        {// Commented out for now, but will be used for loading animation. Loader sometimes gets stuck on screen on Jobs page.
        /* <div
          className="loader-wrapper"
          hidden={this.state.updating === 0} />
        
        <CSSTransition
          in={this.state.updating > 0}
          timeout={400}
          key={"loaderkey"}
          classNames="alert"
          unmountOnExit
        >
          <div className="loader"></div>
        </CSSTransition> */}
        
        {/* section - Page Header */}
        <Section>
          <div className="col py-5">
            <h1 className={styles.pageTitle}>Job View</h1>
          </div>
        </Section>

        {/* section - Utility & Date */}
        <Section hr={true}>
          <div className="col pb-5">
            <div className="date-section d-flex flex-column flex-md-row justify-content-between">
              
              {/* item - Utility */}
              <div className={`col-2 pl-0 mb-4 mb-md-0 ${styles.utility}`}>
                {/* <label className={styles.label}>Utility</label>
                <div className="dropdown" >
                  <Dropdown
                    options={utilsForDropdown}
                    onChange={this.handleSelectUtility}
                    value={selectedUtility}
                    />
                </div> */}
              </div>
              
              {/* item - Show filters */}
              <div className={`${styles.showFilter}`}>
                <div className="d-flex flex-column">
                  <label className={styles.label}>Show</label>

                  <div className="btn-group">
                    <div className={`btn-group-inner d-flex flex-column flex-sm-row ${styles.showItems}`}>
                      <div className={`col px-0 btn-group-inner-item ${styles.showItemsItem}`}>
                        <button type="button" className={`text-center ${styles.inputText} ${this.state.selectedStatus === 'All' ? 'active' : ''}`} onClick={this.updateSelectedStatus}>All</button>
                      </div>
                      <div className={`col px-0 btn-group-inner-item ${styles.showItemsItem}`}>
                        <button type="button" className={`text-center ${styles.inputText} ${this.state.selectedStatus === 'In Estimation' ? 'active' : ''}`} onClick={this.updateSelectedStatus}>In Estimation</button>
                      </div>
                      <div className={`col px-0 btn-group-inner-item ${styles.showItemsItem}`}>
                        <button type="button" className={`text-center ${styles.inputText} ${this.state.selectedStatus === 'In Progress' ? 'active' : ''}`} onClick={this.updateSelectedStatus}>In Progress</button>
                      </div>
                      <div className={`col px-0 btn-group-inner-item ${styles.showItemsItem}`}>
                        <button type="button" className={`text-center ${styles.inputText} ${this.state.selectedStatus === 'Complete' ? 'active' : ''}`} onClick={this.updateSelectedStatus}>Complete</button>
                      </div>
                      
                    </div>
                  </div>
                </div>
              </div>
              
              {/*
              Date Preset / Start / End
              <div className="date">
                <div className="date-inner d-flex flex-column flex-sm-row align-items-start align-items-md-end">
                  
             
                  item - Start Date
                  <div className="d-flex flex-column date-inner-item mb-4 mb-md-0 mx-md-3 px-sm-3 px-md-0 w-100">
                    <label
                      className={styles.label}
                      htmlFor="startDate"
                    >
                      Start Date
                    </label>
                    <input
                      type="text"
                      className={`${styles.inputText} ${styles.dateInput}`}
                      placeholder={startDateFormatted}
                      onClick={this.toggleShowStartDateCalendar} 
                      onBlur={this.hideStartDateCalendar} />
                    <div
                      hidden={!this.state.showStartDateCalendar}
                      className="dateCalendar"
                    >
                      <Calendar
                        onChange={this.onStartDateChange}
                        value={this.state.startDate}
                        className={"modal-calendar"} />
                    </div>
                    </div>
                  
                  item - End Date
                  <div className="d-flex flex-column pl-sm-3 pl-md-0 date-inner-item w-100">
                    <label
                      className={styles.label}
                      htmlFor="endDate"
                    >
                      End Date
                    </label> 
                    <p><input type="text" placeholder="1/31/2021"/></p>
                    <input
                      className={`${styles.inputText} ${styles.dateInput}`}
                      type="text"
                      placeholder="1/31/2021"
                      name="endDate" />
                    
                    
                    <input
                      type="text"
                      className={`${styles.inputText} ${styles.dateInput}`}
                      placeholder={endDateFormatted}
                      onClick={this.toggleShowEndDateCalendar}
                      onBlur={this.hideEndDateCalendar} /> 
                    <div
                      hidden={!this.state.showEndDateCalendar}
                      className="dateCalendar"
                    >
                      <Calendar
                        onChange={this.onEndDateChange}
                        value={this.state.endDate}
                        className={"modal-calendar"} />
                    </div>


                  </div>
                </div>
              </div>
              */}
              
            </div>
          </div>
        </Section>
          
        {/* section - Filters */}
        <Section>
          <div className="col">
            <div className="date-section d-flex flex-column flex-md-row align-items-md-end justify-content-between mt-5">

              
            </div>
          </div>
        </Section>
          
        {/* section - Table */}
        <Section>
          <div className="col">
            <div className="detail-section mt-5 respTable jobs-table-wrapper">
              <CSSTransition in={this.state.jobs.length>0} key={"table"} timeout={1000} classNames="table-fade" mountOnEnter unmountOnExit>
                <Table className="table table-striped">
                  <Thead>
                    <Tr>
                      {// Original Sort Method
                      /* <Th scope="col" onClick={() => this.sortBy('job_number')}><label>Job</label> <svg className={(this.state.sort_dir==="asc"? "sort-asc" : "sort-desc") + (this.state.sort_col === "job_number" ? "" : ' hidden')} version="1.1" id="Capa_1" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 292.362 292.362" fill="black"><g><path d="M286.935,69.377c-3.614-3.617-7.898-5.424-12.848-5.424H18.274c-4.952,0-9.233,1.807-12.85,5.424   C1.807,72.998,0,77.279,0,82.228c0,4.948,1.807,9.229,5.424,12.847l127.907,127.907c3.621,3.617,7.902,5.428,12.85,5.428   s9.233-1.811,12.847-5.428L286.935,95.074c3.613-3.617,5.427-7.898,5.427-12.847C292.362,77.279,290.548,72.998,286.935,69.377z"/></g></svg></Th> */
                      }
                      <Th scope="col" onClick={() => this.handleSorting('sortDir', 'sortBy','job_number')}><label>Job</label><div className={(this.state.sort_dir==="asc"? "sort-asc" : "sort-desc") + (this.state.sort_col === "job_number" ? "" : ' hidden') + (' sort-icon')}  alt="Sort Direction"></div></Th>
                      <Th scope="col" onClick={() => this.handleSorting('sortDir', 'sortBy','selected_utility_name')}><label>Utility</label> <div className={(this.state.sort_dir==="asc"? "sort-asc" : "sort-desc") + (this.state.sort_col === "selected_utility_name" ? "" : ' hidden') + (' sort-icon')}  alt="Sort Direction"></div></Th>
                      <Th scope="col" onClick={() => this.handleSorting('sortDir', 'sortBy','job_type')}><label>Job Type</label> <div className={(this.state.sort_dir==="asc"? "sort-asc" : "sort-desc") + (this.state.sort_col === "job_type" ? "" : ' hidden') + (' sort-icon')}  alt="Sort Direction"></div></Th>
                      <Th scope="col" onClick={() => this.handleSorting('sortDir', 'sortBy','status')}><label>Status</label> <div className={(this.state.sort_dir==="asc"? "sort-asc" : "sort-desc") + (this.state.sort_col === "status" ? "" : ' hidden') + (' sort-icon')}  alt="Sort Direction"></div></Th>
                      <Th scope="col" onClick={() => this.handleSorting('sortDir', 'sortBy','ticket_count')}><label># Tickets</label> <div className={(this.state.sort_dir==="asc"? "sort-asc" : "sort-desc") + (this.state.sort_col === "ticket_count" ? "" : ' hidden') + (' sort-icon')}  alt="Sort Direction"></div></Th>
                      <Th scope="col" onClick={() => this.handleSorting('sortDir', 'sortBy','created_name')}><label>Created By</label> <div className={(this.state.sort_dir==="asc"? "sort-asc" : "sort-desc") + (this.state.sort_col === "created_name" ? "" : ' hidden') + (' sort-icon')}  alt="Sort Direction"></div></Th>
                      <Th scope="col" className="text-center" onClick={() => this.handleSorting('sortDir', 'sortBy', 'due_date')}><label>Due Date</label> <div className={(this.state.sort_dir==="asc"? "sort-asc" : "sort-desc") + (this.state.sort_col === "due_date" ? "" : ' hidden') + (' sort-icon')}  alt="Sort Direction"></div></Th>
                      <Th scope="col" className="text-center" onClick={() => this.handleSorting('sortDir', 'sortBy', 'date_completed')}><label>Date Completed</label> <div className={(this.state.sort_dir==="asc"? "sort-asc" : "sort-desc") + (this.state.sort_col === "date_completed" ? "" : ' hidden') + (' sort-icon')}  alt="Sort Direction"></div></Th>

                    </Tr>
                    
                  </Thead>
                  <Tbody>
                    {
                    this.state.filteredJobs.map((job) => {
                      return (
                        <Tr key={job.id + "a"} className="clickable-row" onClick={() => window.location="/job?id=" + job.id}>
                          <Td scope="row" key={job.id}>{job.job_number}</Td>
                          <Td>{job.selected_utility_name}</Td>   
                          
                          <Td>{job.job_type === 1 ? 'Estimate' : 'Normal'}</Td>
                          <Td>{job.status}</Td>
                          <Td>{job.ticket_count}</Td>
                          <Td>{job.foreman_name}</Td>
                          {/* <Td>{job.created_name}</Td> */}
                          <Td className="text-center">{job.due_date ? moment(job.due_date, 'YYYY-MM-DD').format('MM/DD/YYYY') : ''}</Td>
                          <Td className="text-center">{job.date_completed ? new Intl.DateTimeFormat("en-US", {
                            year: "numeric",
                            month: "long",
                            day: "2-digit"
                          }).format(new Date(job.date_completed)) : '--'}</Td>
                      </Tr>)
                    })
                    }
                  </Tbody>
                </Table>
              </CSSTransition>
            </div>
          </div>
        </Section>

        {/* <hr></hr> */}
          
        {/* section - Btn Action */}
        <Section newclassName="buttonAction">
          <div className="col pt-4">
            {/* <div className="btn-action d-flex justify-content-end text-right" onClick={()=> {this.props.history.replace('/job')}}> */}
            <div className="btn-action d-flex justify-content-end text-right">
              <button
                type="button"
                className={`btn btn-primary d-flex text-center text-white ${styles.btnIcon}`}
                onClick={this.toggleCreateJob}
              >
                <svg
                  width="11"
                  height="11"
                  viewBox="0 0 11 11"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 4H11V7L7 7V11H4V7L0 7V4.04102H4V0H7V4Z"
                    fill="white" />
                </svg>
                <span>Create Job</span>
              </button>
            </div>
          </div>
        </Section>

        {newJob && 
          <div
            className={`modal fade show modalContain`}
            id="createJobModal"
            style={{display:"block"}}
            tabIndex="-1"
            aria-modal="true"
            role="dialog"
            aria-labelledby={`createJobModalLabel`}
            aria-hidden="true"
          >
            <div
              className={`modal-dialog modalDialog modal-lg modal-dialog-scrollable`}
              role="document"
            >
              <div className={`modal-content modalContent`}>
                {/* <fieldset className="modalFieldset"> */}
    
                  {/* MODAL HEADER */}
                  <div className={`modal-header align-items-center modalHeader`}>
                    <h5
                      className={`modal-title modalTitle`}
                      id={`createJobModalLabel`}
                    >
                      Create Job
                    </h5>
                    <button
                      type="button"
                      className={`close modalHeaderClose`}
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={this.checkToggleCreateJob}
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  
                  {/* MODAL BODY */}
                  <div className={`modal-body modalBody`}>
                    
                    <div className="container-fluid">
                      
                      {/* section - Job */}
                      <div className="row section sectionJob">

                        {/* item - Job Number */}
                        <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item jobNumber">
                          <label className="labelTitle lg">Job (*)</label>
                          <input
                            id="jobName"
                            type="text"
                            onChange={this.handleJobNumber} 
                            onBlur={this.checkExistingJobNumber}
                            value={newJob ? newJob?.jobNumber : ''}
                            />
                         
                        </div>
                      {/* job number - errors */}
                        <div 
                          className="job-exists-error" 
                          style={{ display: job_number_exists && job_number_exists === 1 ? 'block' : 'none'}} 
                        >
                          <span style={{color: "#ff0000"}}>*That job number already exists. Please use a different number for the job.</span>
                        </div>

                        {/* item - Job Type */}
                        <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item jobType">
                          <label className="labelTitle lg">Job Type</label>
                          <div className="d-flex flex-column flex-sm-row radioItems">
                            <input
                              type="radio"
                              className="btn-check"
                              name="jobType"
                              id="jobTypeNormal"
                              checked={newJob && newJob.job_type === 0}
                              readOnly />
                            <label
                              className="btn btn-secondary"
                              htmlFor="jobTypeNormal"
                              onClick={() => this.handleSelectJobType('normal')}
                            >
                              Normal
                            </label>
                            <input
                              type="radio"
                              className="btn-check"
                              name="jobType"
                              id="jobTypeEstimation"
                              checked={newJob && newJob.job_type === 1}
                              readOnly />
                            <label
                              className="btn btn-secondary"
                              htmlFor="jobTypeEstimation"
                              onClick={() => this.handleSelectJobType('estimation')}
                            >
                              Estimation
                            </label>
                          </div>
                        </div>

                        {/* item - Due Date */}
                        <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item date">
                          <label className="labelTitle lg">Due Date (*)</label>
                          <input
                            type="text"
                            id="calendar"
                            placeholder="Select a Date"
                            onClick={this.toggleShowDueDateCalendar}
                            value={newJob ? 
                                          (newJob?.due_date ? moment(newJob.due_date).format('MM/DD/YYYY') 
                                                            :moment(newJob.due_date_default).format('MM/DD/YYYY') )
                                          : moment().format('MM/DD/YYYY')}
                            readOnly={true}
                             />
                          <div
                            hidden={!this.state.showDueDateCalendar}
                            className="dateCalendar"
                            id="calendar_div"
                          >
                            <Calendar
                            id="calendar_cal"
                              onChange={this.onDueDateChange}
                              value={newJob ? (newJob.due_date ? new Date(newJob.due_date) : new Date(newJob.due_date_default)) : new Date() }
                              className={"modal-calendar"}
                               />
                          </div>
                        </div>
                      </div>
                        
                      {/* section - Foreman */}
                      <div className="row section sectionForeman">
                        
                       
                        
                        {/* item - Utility */}
                        {/* <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item utility">
                          <label className="labelTitle lg">Utility (*)</label>
                          <Dropdown
                            options={utilsForDropdown}
                            onChange={this.handleSelectUtility}
                            // value={selectedUtility.label ? selectedUtility.label : ''}
                            placeholder="Utility is required" />
                        </div> */}
                        <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item utility">
                          <label className="labelTitle lg">Utility (*)</label>
                          <Dropdown
                            options={utilsForDropdownCreate}
                            onChange={this.handleNewSelectUtility}
                            value={newJob && newJob.selected_utility_id ? newJob.selected_utility_name : ''}
                            placeholder="Utility is required" />
                        </div>
                        
                        {/* item - Drag & Drop */}
                        <div className={`col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item uploadSection ${this.state.loadingNewPacket ? styles.loading : ''}`}>
                          <div
                            className={`${styles.loaderBox}`}
                            style={{
                              display: this.state.loadingNewPacket ? 'block' : 'none',
                            }}
                          >
                            
                            <div className={`${styles.loaderLogo}`}>
                              <svg
                                className={`${styles.loaderLogoSvg}`}
                                style={{
                                  animationName: 'spin',
                                }}
                                width="100" height="100" viewBox="0 0 300 300" fill="none" xmlns="http://www.w3.org/2000/svg" ><path fillRule="evenodd" clipRule="evenodd" d="M117.236 117.564L135.488 51.7447C92.1144 58.0338 57.8376 92.408 51.6958 135.829L27.8827 142.432C31.5571 80.9652 80.6763 31.7417 142.099 27.9031L149.836 0L149.836 27.6621V50.7138L149.836 149.836L150 150L182.436 117.564L247.963 135.734C241.785 92.3581 207.526 58.0292 164.185 51.7447L157.574 27.9031C218.965 31.7398 268.066 80.9159 271.784 142.34L300 150.164L150.164 150.164L182.436 182.436L164.279 247.914C207.349 241.626 241.429 207.643 247.863 164.621L271.742 158C267.712 219.081 218.792 267.897 157.666 271.763L149.836 300L149.836 272.01V248.959L149.836 150.491L117.564 182.764L51.7948 164.526C58.1928 207.593 92.292 241.622 135.393 247.914L142.006 271.763C80.8492 267.895 31.9107 219.032 27.9244 157.907L0 150.164L27.6625 150.164H50.7143L149.836 150.164L117.236 117.564Z" fill="#FFCC18"></path></svg>
                            </div>
                            <div className={`${styles.loaderBg}`} />
                          </div>
                          <div className={`upload-section ${styles.itemFull}`}>
                            <label className="hide">Drag & Drop Packet of Work PDFs (*)</label>
                            <div style={{display: 'none'}}>
                              <input type="file" ref={this.newJobPacket} 
                               onClick={(e)=> {e.target.value = null}} //workaround -> there's a known issue where you cannot upload the same file again
                              onChange={(e) => this.handlePDFJobPacketUpload(e) }/>
                          </div>
                            <DragAndDrop
                              copy="Drag &amp; Drop Packet of Work PDFs"
                              handleDrop={this.handlePacketDrop}
                              handleFileSelect={this.handleFileSelectClick}
                              removeFiles={this.resetPacketOfWorkFile}
                              file={newJob && newJob.work_packet_name ? {name:newJob.work_packet_name, url:newJob.work_packet_url} : {}} />
                              
                          </div>
                        </div>
                        {loadingNewPacket && (
                          <div style={{ textAlign: 'center', marginTop: '20px' }}>
                              {showSpinner && (
                                  <div className="spinner" style={{ animationName: 'spin', marginBottom: '20px' }}></div>
                              )}
                              {showNetworkError && (
                                  <div style={{ marginTop: '10px', color: 'red' }}>
                                      <p>An error has occurred while uploading. Please retry your request.</p>
                                      <button className="btn btn-secondary" onClick={this.handlePDFRetry}>Retry</button>
                                  </div>
                              )}
                          </div>
                        )}
                      </div>
                        
                      {/* section - Emergency */}
                      <div className="row mb-0 section sectionEmergency">
                        
                         {/* item - Foreman */}
                         <div
                          className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item foreman"
                         >
                          <label className="labelTitle lg">Foreman</label>
                          <Dropdown
                            key={"One"}
                            options={foremenForDropdown} 
                            onChange={this.handleSelectForeman}
                            value={newJob && newJob.foreman_id ? newJob.foreman_name : ''} 
                            placeholder="" />
                        </div>

                          {/* item - Work Contact Phone */}
                          <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item workContactPhone">
                          <label
                            className="labelTitle lg"
                            htmlFor="work_contact_phone"
                          >
                            Work Contact Phone
                          </label>
                          <input
                            type="text"
                            name="work_contact_phone"
                            id="work_contact_phone"
                            onChange={this.handleWorkContactPhone} 
                            value={newJob ? newJob.work_contact_phone : ''}
                            />
                        </div>
                        
                        
                        {/* item - Hospital Name */}
                        <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item hospitalName">
                          <label
                            className="labelTitle lg"
                            htmlFor="hospName"
                          >
                            Hospital Name
                          </label>
                          <input
                            type="text"
                            name="hospName"
                            id="hospName"
                            onChange={this.handleHospName} 
                            value={newJob ? newJob.hospital_name : ''}
                            />
                        </div>
                        
                        {/* item - Hospital Address */}
                        <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item hospitalAddress">
                          <label
                            className="labelTitle lg"
                            htmlFor="hospAddress"
                          >
                            Hospital Address
                          </label>
                          <input
                            type="text"
                            name="hosAddress"
                            id="hospAddress"
                            onChange={this.handleHospAddress} 
                            value={newJob ? newJob.hospital_address : ''}
                            />
                        </div>

                             {/* item - EHASP */}
                                {/* this is a textbox where all tickets(poles) on this job will share the same EHASP url to a cloud hosted document. This will be editable on each pole/ticket once saved */}

                        <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item ehasp">
                          <label
                            className="labelTitle lg"
                            htmlFor="ehasp_override"
                          >
                            EHASP
                            <span className={`d-block`} style={{ color: '#999999', fontSize: '1.2rem', fontWeight: 500, lineHeight: '1.6rem' }}>All poles, each pole can be modified later</span>
                          </label>
                          <input
                            type="text"
                            name="ehasp_override"
                            id="ehasp_override"
                            onChange={this.handleJobEhasp} 
                            value={newJob ? newJob.ehasp_override : ''}
                            />
                        </div>

                                
                        <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item voltage">
                          <label
                            className="labelTitle lg"
                            htmlFor="voltage"
                          >
                            Primary Voltage - All Poles
                            <span className={`d-block`} style={{ color: '#999999', fontSize: '1.2rem', fontWeight: 500, lineHeight: '1.6rem' }}>Leave blank if you want to populate from excel column</span>
                          </label>
                          <input
                            type="text"
                            name="secondary_voltage_override"
                            id="secondary_voltage_override"
                            onChange={this.handleJobPrimaryVoltage} 
                            value={newJob ? newJob.primary_voltage_override : ''}
                            />
                        </div>
                        <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item voltage">
                          <label
                            className="labelTitle lg"
                            htmlFor="voltage"
                          >
                            Secondary Voltage - All poles
                            <span className={`d-block`} style={{ color: '#999999', fontSize: '1.2rem', fontWeight: 500, lineHeight: '1.6rem' }}>Leave blank if you want to populate from Excel column</span>
                          </label>
                          <input
                            type="text"
                            name="primary_voltage_override"
                            id="primary_voltage_override"
                            onChange={this.handleJobSecondaryVoltage} 
                            value={newJob ? newJob.secondary_voltage_override : ''}
                            />
                        </div>
                        
                        <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item voltage">
                          <label
                            className="labelTitle lg"
                            htmlFor="voltage"
                          >
                            Arc Rating - All Poles
                            <span className={`d-block`} style={{ color: '#999999', fontSize: '1.2rem', fontWeight: 500, lineHeight: '1.6rem' }}>Leave blank if you want to populate from Excel column</span>
                          </label>
                          <input
                            type="text"
                            name="arc_rating_override"
                            id="arc_rating_override"
                            onChange={this.handleJobArcRating} 
                            value={newJob ? newJob.arc_rating_override : ''}
                            />
                        </div>
                        
                        
                        
                      </div>
                        
                      {/* section - Excel */}
                      <div className="row mb-0 section sectionExcel" id='sectionExcel'>
                        
                        {/* item - Drag & Drop */}
                        <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item uploadSection">
                            <div
                                style={{
                                    position: 'absolute',
                                    top: '0',
                                    left: '0',
                                    width: '100%',
                                    height: '100%',
                                    display: this.state.loadingNewTickets ? 'block' : 'none',
                                    textAlign: 'center',
                                    paddingTop: '5px',
                                }}
                            >
                                <div className={`${styles.loaderLogo}`}>
                                    <svg
                                        className={`${styles.loaderLogoSvg}`}
                                        style={{
                                            animationName: 'spin',
                                        }}
                                        width="100"
                                        height="100"
                                        viewBox="0 0 300 300"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M117.236 117.564L135.488 51.7447C92.1144 58.0338 57.8376 92.408 51.6958 135.829L27.8827 142.432C31.5571 80.9652 80.6763 31.7417 142.099 27.9031L149.836 0L149.836 27.6621V50.7138L149.836 149.836L150 150L182.436 117.564L247.963 135.734C241.785 92.3581 207.526 58.0292 164.185 51.7447L157.574 27.9031C218.965 31.7398 268.066 80.9159 271.784 142.34L300 150.164L150.164 150.164L182.436 182.436L164.279 247.914C207.349 241.626 241.429 207.643 247.863 164.621L271.742 158C267.712 219.081 218.792 267.897 157.666 271.763L149.836 300L149.836 272.01V248.959L149.836 150.491L117.564 182.764L51.7948 164.526C58.1928 207.593 92.292 241.622 135.393 247.914L142.006 271.763C80.8492 267.895 31.9107 219.032 27.9244 157.907L0 150.164L27.6625 150.164H50.7143L149.836 150.164L117.236 117.564Z"
                                            fill="#FFCC18"
                                        ></path>
                                    </svg>
                                </div>
                                <div className={`${styles.loaderBg}`} />
                            </div>
                            <div className={`upload-section ${styles.itemFull}`}>
                                <label className="hide">Drag & Drop Excel file of tickets</label>
                                <div style={{ display: 'none' }}>
                                    <input
                                        type="file"
                                        ref={this.newExcelFileRef}
                                        onClick={(e) => {
                                            e.target.value = null;
                                        }}
                                        onChange={(e) => {
                                            this.handleExcelJobPacketUpload(e);
                                        }}
                                    />
                                </div>
                                <DragAndDrop
                                    copy="Drag & Drop Excel file of tickets"
                                    handleDrop={this.handleExcelDrop}
                                    removeFiles={this.resetExcel}
                                    handleFileSelect={this.handleExcelFileSelectClick}
                                    edit={this.editExcel}
                                    file={
                                        newTickets && newTickets.ticket_file_name
                                            ? { name: newTickets.ticket_file_name, url: newTickets.ticket_file_url }
                                            : {}
                                    }
                                />
                            </div>
                           
                        </div>
                         {this.state.showExcelNetworkError && (
                                  <div style={{ justifyItems:'center', marginTop: '10px', color: 'red' }}>
                                      <p>An error has occured while uploading. Please retry your request. </p>
                                      <button className="btn btn-secondary" onClick={this.handleExcelRetry}>Retry</button>
                                  </div>
                            )}
                      </div>
                    </div>
          
                  </div>
                  
                  {/* MODAL FOOTER */}
                  <div className={`modal-footer modalFooter`}>
                    <button
                      type="button"
                      className={`btn btn-secondary modalFooterButton`}
                      data-dismiss="modal"
                      onClick={this.checkToggleCreateJob}
                    >
                      Close
                    </button>

                    {/* <button
                      type="button"
                      className={`btn btn-danger modalFooterButton`}
                      onClick={this.toggleExcelMapping}
                    >
                    EXCEL FIELDS
                    </button> */}

                    <button
                      type="button"
                      className={`btn btn-primary modalFooterButton`}
                      onClick={this.saveJob}
                      disabled={!this.state.canSaveJob}
                    >
                      Save
                    </button>
                  </div>
                
                {/* </fieldset> */}
              </div>
            </div>
          </div>
        }

        {this.state.newExcel && this.state.newTickets &&
          <div
            className={`modal fade show modalContain`}
            id={`${styles.excelMappingModal}`}
            style={{display:"block"}}
            tabIndex="-1"
            aria-modal="true"
            role="dialog"
            aria-labelledby={`excelMappingLabel`}
            aria-hidden="true"
          >
            <div
              className={`modal-dialog modalDialog modal-lg modal-dialog-scrollable ${styles.modalDialog}`}
              role="document"
            >
              <div className={`modal-content modalContent ${styles.modalContent}`}>
                {/* <fieldset className="modalFieldset"> */}
    
                  {/* MODAL HEADER */}
                  <div className={`modal-header align-items-center modalHeader`}>
                    <h5
                      className={`modal-title modalTitle`}
                      id={`excelMappingLabel`}
                    >
                      Excel Column Mapping
                    </h5>
                    <button
                      type="button"
                      className={`close modalHeaderClose`}
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={this.toggleExcelMapping}
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  
                  {/* MODAL BODY */}
                  
                  <div className={`modal-body modalBody ${styles.modalBody}`}>
                    
                    <div className="container-fluid">

                      {/* tabs */}
                      <section className={`row section noBorder tabs`}>
                        <div className={`col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item labelOnly`}>Show</div>
                        <div className={`col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item noTopPad radioItems`}>
                          <div className={`d-flex flex-column flex-sm-row radioItems`}>
                            <input
                              type="radio"
                              className={`btn-check`}
                              name="unitType"
                              id="unitTracking"
                              checked={this.state.excelActiveTab === 'tracking'}
                              readOnly />
                            <label
                              className={`btn btn-secondary`}
                              htmlFor="unitTracking"
                              onClick={() => this.handleSelectExcelMappingTab('tracking')}
                            >
                              Unit Tracking
                            </label>
                            <input
                              type="radio"
                              className={`btn-check`}
                              name="unitType"
                              id="unitLibrary"
                              checked={this.state.excelActiveTab === 'library'}
                              readOnly />
                            <label
                              className={`btn btn-secondary`}
                              htmlFor="unitLibrary"
                              onClick={() => this.handleSelectExcelMappingTab('library')}
                            >
                              Unit Library
                            </label>
                          </div>
                        </div>
                      </section>

                      {/* Tracking Tab */}
                      {this.state.excelActiveTab === 'tracking' &&
                      <section className={`row section`}>

                        {/* item - Work Order Number* */}
                        <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item workOrderNumber">
                          <label className="labelTitle lg">Work Order Number*</label>
                          <Dropdown
                              key={"One"}
                              options={newTickets.availableJobColumns} 
                              onChange={(e) => {
                                const updateTickets = this.calcTicketExcelColumn('ticket', 'work_order', e.value)
                                this.setNewTickets(updateTickets)
                              }} 
                              value={newTickets?.ticketsMappings?.work_order ?? DEFAULT_DROPDOWN_VALUE} 
                              placeholder="" />
   
                        </div>
                      
                        {/* item - Pole Number* */}
                        <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item poleNumber">
                          <label className="labelTitle lg">Pole *</label>
                          <Dropdown
                              key={"One"}
                              options={newTickets.availableJobColumns} 
                              onChange={(e) => {
                                const updateTickets = this.calcTicketExcelColumn('ticket', 'pole', e.value)
                                this.setNewTickets(updateTickets) 
                              }}
                              value={newTickets?.ticketsMappings?.pole ?? DEFAULT_DROPDOWN_VALUE}
                              placeholder="" /> 
                        </div>
                      
                        {/* item - Line Number* */}
                        <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item lineNumber">
                          <label className="labelTitle lg">Line *</label>
                          <Dropdown
                              key={"One"}
                              options={newTickets.availableJobColumns} 
                              onChange={(e) => {
                                const updateTickets = this.calcTicketExcelColumn('ticket', 'line', e.value)
                                this.setNewTickets(updateTickets) 
                              }}
                              value={newTickets?.ticketsMappings?.line ?? DEFAULT_DROPDOWN_VALUE}
                              placeholder="" />
                        </div>

                        {/* item - Pole ID */}
                        <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item poleId">
                          <label className="labelTitle lg">Pole ID</label>
                          <Dropdown
                              key={"One"}
                              options={newTickets.availableJobColumns} 
                              onChange={(e) => {
                                const updateTickets = this.calcTicketExcelColumn('ticket', 'pole_id', e.value)
                                this.setNewTickets(updateTickets) 
                              }}
                              value={newTickets?.ticketsMappings?.pole_id ?? DEFAULT_DROPDOWN_VALUE}
                              placeholder="" />
                        </div>

                        {/* item - Line ID */}
                        <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item lineId">
                          <label className="labelTitle lg">Line ID</label>
                          <Dropdown
                              key={"One"}
                              options={newTickets.availableJobColumns} 
                              onChange={(e) => {
                                const updateTickets = this.calcTicketExcelColumn('ticket', 'line_id', e.value)
                                this.setNewTickets(updateTickets) 
                              }}
                              value={newTickets?.ticketsMappings?.line_id ?? DEFAULT_DROPDOWN_VALUE}
                              placeholder="" />
                        </div>

                        {/* item - Due Date */}
                        <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item dueDate">
                          <label className="labelTitle lg">Due Date</label>
                          <Dropdown
                              key={"One"}
                              options={newTickets.availableJobColumns} 
                              onChange={(e) => {
                                const updateTickets = this.calcTicketExcelColumn('ticket', 'due_date', e.value)
                                this.setNewTickets(updateTickets) 
                              }}
                              value={newTickets?.ticketsMappings?.due_date ?? DEFAULT_DROPDOWN_VALUE}
                              placeholder="" />
                        </div>
                      
                        {/* item - Geo Latitude */}
                        <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item geoLatitude">
                          <label className="labelTitle lg">Geo Latitude</label>
                          <Dropdown
                              key={"One"}
                              options={newTickets.availableJobColumns} 
                              onChange={(e) => {const updateTickets = this.calcTicketExcelColumn('ticket', 'geo_lat', e.value)
                              this.setNewTickets(updateTickets) 
                            }}
                              value={newTickets?.ticketsMappings?.geo_lat ?? DEFAULT_DROPDOWN_VALUE}
                              placeholder="" />
                        </div>
                      
                        {/* item - Geo Longitude */}
                        <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item geoLongitude">
                          <label className="labelTitle lg">Geo Longitude</label>
                          <Dropdown
                              key={"One"}
                              options={newTickets.availableJobColumns} 
                              onChange={(e) => {
                                const updateTickets = this.calcTicketExcelColumn('ticket', 'geo_lon', e.value)
                                this.setNewTickets(updateTickets) 
                            }}
                            value={newTickets?.ticketsMappings?.geo_lon ?? DEFAULT_DROPDOWN_VALUE}
                              placeholder="" />
                        </div>
                      
                        {/* item -Primary Voltage */}
                        <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item voltage">
                          <label className="labelTitle lg">Primary Voltage</label>
                          <Dropdown
                            disabled={this.state.newJob?.primary_voltage_override}
                              key={"One"}
                              options={newTickets.availableJobColumns} 
                              onChange={(e) => {
                                const updateTickets = this.calcTicketExcelColumn('ticket', 'primary_voltage', e.value)
                              this.setNewTickets(updateTickets) 
                            }}
                            value={this.state.newJob?.primary_voltage_override ? `Overridden: ${this.state.newJob?.primary_voltage_override}` : newTickets?.ticketsMappings?.primary_voltage ?? DEFAULT_DROPDOWN_VALUE}
                            placeholder="" />
                        </div>
                      
                        {/* item - Secondary Voltage */}
                        <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item voltage">
                          <label className="labelTitle lg">Secondary Voltage</label>
                          <Dropdown
                              key={"One"}
                              disabled={this.state.newJob?.secondary_voltage_override}
                              options={newTickets.availableJobColumns} 
                              onChange={(e) => {
                                const updateTickets = this.calcTicketExcelColumn('ticket', 'secondary_voltage', e.value)
                              this.setNewTickets(updateTickets) 
                            }}
                            value={this.state.newJob?.secondary_voltage_override ? `Overridden: ${this.state.newJob?.secondary_voltage_override}` :  newTickets?.ticketsMappings?.secondary_voltage ?? DEFAULT_DROPDOWN_VALUE}
                              placeholder="" />
                        </div>
                      
                        {/* item - Arc Rating Voltage */}
                        <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item voltage">
                          <label className="labelTitle lg">Arc Rating</label>
                          <Dropdown
                              key={"One"}
                              disabled={this.state.newJob?.arc_rating_override}
                              options={newTickets.availableJobColumns} 
                              onChange={(e) => {
                                const updateTickets = this.calcTicketExcelColumn('ticket', 'arc_rating', e.value)
                              this.setNewTickets(updateTickets) 
                            }}

                              value={this.state.newJob?.arc_rating ? `Overridden: ${this.state.newJob?.arc_rating}` : newTickets?.ticketsMappings?.arc_rating ?? DEFAULT_DROPDOWN_VALUE}
                              placeholder="" />  
                        </div>
                      
                        {/* item - Street */}
                        <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item street">
                          <label className="labelTitle lg">Street</label>
                          <Dropdown
                              key={"One"}
                              options={newTickets.availableJobColumns} 
                              onChange={(e) => {
                                const updateTickets = this.calcTicketExcelColumn('ticket', 'street', e.value)
                                this.setNewTickets(updateTickets) 
                              }} 
                              value={newTickets?.ticketsMappings?.street ?? DEFAULT_DROPDOWN_VALUE}
                              placeholder="" />
                        </div>
                      
                        {/* item - Unit Task* */}
                        <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item unitTask">
                          <label className="labelTitle lg">Unit Task*</label>
                          <Dropdown
                              key={"One"}
                              options={newTickets.availableJobColumns} 
                              onChange={(e) => {
                                const updateTickets = this.calcTicketExcelColumn('ticket', 'unit_task', e.value)
                                this.setNewTickets(updateTickets) 
                            }}
                              value={newTickets?.ticketsMappings?.unit_task ?? DEFAULT_DROPDOWN_VALUE}
                              placeholder="" />
                        </div>
                      
                        {/* item - Desc* */}
                        <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item unitTask">
                          <label className="labelTitle lg">Description</label>
                          <Dropdown
                              key={"One"}
                              options={newTickets.availableJobColumns} 
                              onChange={(e) => {
                                const updateTickets = this.calcTicketExcelColumn('ticket', 'desc', e.value)
                                this.setNewTickets(updateTickets) 
                            }}
                              value={newTickets?.ticketsMappings?.desc ?? DEFAULT_DROPDOWN_VALUE}
                              placeholder="" />
                        </div>
                      
                        {/* item - Quantity* */}
                        <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item quantity">
                          <label className="labelTitle lg">Quantity*</label>
                          <Dropdown
                              key={"One"}
                              options={newTickets.availableJobColumns} 
                              onChange={(e) => {const updateTickets = this.calcTicketExcelColumn('ticket', 'qty', e.value)
                              this.setNewTickets(updateTickets) 
                            }} 
                              value={newTickets?.ticketsMappings?.qty ?? DEFAULT_DROPDOWN_VALUE}
                              placeholder="" />
                        </div>
                      
                      </section>
                      }

                      {this.state.excelActiveTab === 'library' &&
                      <section className={`row section`}>

                        {/* item - Family */}
                        <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item family">
                          <label className="labelTitle lg">Family</label>
                          <Dropdown
                              key={"One"}
                              options={newTickets.availableLibraryColumns} 
                              onChange={(e) => {const updateTickets = this.calcTicketExcelColumn('library', 'family', e.value)}} 
                              value={newTickets?.libraryMappings?.family ?? DEFAULT_DROPDOWN_VALUE}
                              placeholder="" />
                        </div>
                      
                        {/* item - Unit Code */}
                        <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item unitCode">
                          <label className="labelTitle lg">Unit Code</label>
                          <Dropdown
                              key={"One"}
                              options={newTickets.availableLibraryColumns} 
                              onChange={(e) => {const updateTickets = this.calcTicketExcelColumn('library', 'code', e.value)}} 
                              value={newTickets?.libraryMappings?.code ?? DEFAULT_DROPDOWN_VALUE}
                              placeholder="" />
                        </div>
                      
                        {/* item - Type */}
                        <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item type">
                          <label className="labelTitle lg">Type</label>
                          <Dropdown
                              key={"One"}
                              options={newTickets.availableLibraryColumns} 
                              onChange={(e) => {const updateTickets = this.calcTicketExcelColumn('library', 'type', e.valuee)}} 
                              value={newTickets?.libraryMappings?.type ?? DEFAULT_DROPDOWN_VALUE}
                              placeholder="" />
                        </div>
                      
                        {/* item - Action */}
                        <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item action">
                          <label className="labelTitle lg">Action</label>
                          <Dropdown
                              key={"One"}
                              options={newTickets.availableLibraryColumns} 
                              onChange={(e) => {const updateTickets = this.calcTicketExcelColumn('library', 'action', e.valuee)}} 
                              value={newTickets?.libraryMappings?.action ?? DEFAULT_DROPDOWN_VALUE}
                              placeholder="" />
                        </div>
                      
                        {/* item - UOM */}
                        <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item uom">
                          <label className="labelTitle lg">UOM</label>
                          <Dropdown
                              key={"One"}
                              options={newTickets.availableLibraryColumns} 
                              onChange={(e) => {const updateTickets = this.calcTicketExcelColumn('library', 'uom', e.value)}} 
                              value={newTickets?.libraryMappings?.uom ?? DEFAULT_DROPDOWN_VALUE}
                              placeholder="" />
                        </div>
                      
                        {/* item - Description */}
                        <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item description">
                          <label className="labelTitle lg">Description</label>
                          <Dropdown
                              key={"One"}
                              options={newTickets.availableLibraryColumns} 
                              onChange={(e) => {const updateTickets = this.calcTicketExcelColumn('library', 'desc', e.value)}} 
                              value={newTickets?.libraryMappings?.desc ?? DEFAULT_DROPDOWN_VALUE}
                              placeholder="" />
                        </div>
                      
                        {/* item - Notes */}
                        <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item Notes">
                          <label className="labelTitle lg">Notes</label>
                          <Dropdown
                              key={"One"}
                              options={newTickets.availableLibraryColumns} 
                              onChange={(e) => {const updateTickets = this.calcTicketExcelColumn('library', 'notes', e.value)}} 
                              value={newTickets?.libraryMappings?.notes ?? DEFAULT_DROPDOWN_VALUE}
                              placeholder="" />
                        </div>
                      
                      </section>
                      }
                      
                    </div>
                  </div>
                  
                  {/* MODAL FOOTER */}
                  <div className={`modal-footer modalFooter`}>
                    <button
                      type="button"
                      className={`btn btn-secondary modalFooterButton`}
                      data-dismiss="modal"
                      onClick={this.toggleExcelMapping}
                    >
                      Close
                    </button>

                    <button
                      type="button"
                      className={`btn btn-primary modalFooterButton`}
                      onClick={() => {this.saveExcelMappings();this.toggleExcelMapping()}}
                      disabled={!this.state.canSaveExcel}
                    >
                      Save
                    </button>
                  </div>
                
                {/* </fieldset> */}
              </div>
            </div>
          </div>
        }
        
      </div>
    );
  }    
}

export default Jobs